<template>
  <hr class="my-6 border-t border-gray-100 dark:border-gray-700">
</template>

<script>
export default {
  name: 'Divider'
}
</script>
